export default {"src":"/_next/static/media/parallel_handcuffs_24.ee382430.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};